import React from "react";
import styled from "styled-components";
import Logo from "./Logo";
import HelpIcon from "./assets/help.svg"; 
import AccountIcon from "./assets/settings.svg";
import { useTranslation } from "react-i18next";
import { t } from "i18next";

const Footer = styled.footer`
  display: grid;
  grid-template-columns: 1fr 2fr;
  background-color: unset;
  padding: 20px;
  margin: 80px auto;
  width: 100%;
  @media (max-width: 834px) {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px 12px;
    margin: 40px auto 24px;
  }
`;

const FooterLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FooterRight = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  > div {
    display: flex;
    justify-content: space-around;
  }
  @media (max-width: 834px) {
    gap: 12px;
    > div {
      flex-direction: column;
      gap: 16px;
      align-items: center;
    }
  }
`;

const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;

  a {
    text-decoration: none;
    color: var(--color-background-main);

    &:hover {
      color: #6c45e7;
    }
  }
  @media (max-width: 834px) {
    align-items: center;
  }
`;

const HelpSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media (max-width: 834px) {
    align-items: center;
  }
`;

const HelpItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  .help-text p {
    font-weight: var(--font-weight-h5);
  }

  .help-text a {
    color: var(--color-background-main);

    &:hover {
      text-decoration: underline;
    }
  }
  @media (max-width: 834px) {
    text-align: center;
    .help-text p {
      margin: 0;
    }
  }
`;

const FooterIcon = styled.img`
  width: 20px;
  height: 20px;
`;

const FooterRights = styled.p`
  font-size: 12px;
  color: #48504b;
  margin-top: 10px;
  margin-inline: auto;
  @media (max-width: 834px) {
    text-align: center;
  }
`;

const StartupFooter = () => {
    const { t } = useTranslation();
  return (
    <Footer>
      <FooterLeft>
        <div className="logo-section">
          <Logo />
        </div>
      </FooterLeft>

      <FooterRight>
        <div>
          <FooterLinks>
            <a href="#">{t("footer.about")}</a>
            <a href="#">{t("footer.privacy&terms")}</a>
          </FooterLinks>

          <HelpSection>
            <HelpItem>
              <FooterIcon src={HelpIcon} alt="Help" />
              <div className="help-text">
                <p>{t("footer.queries")}</p>
                <a href="#">{t("footer.query_subheading")}</a>
              </div>
            </HelpItem>

            <HelpItem>
              <FooterIcon src={AccountIcon} alt="Account" />
              <div className="help-text">
                <p>{t("footer.account&privacy")}</p>
                <a href="#">{t("footer.privacy_subheading")}</a>
              </div>
            </HelpItem>
          </HelpSection>
        </div>

        <FooterRights>{t("footer.rights")}</FooterRights>
      </FooterRight>
    </Footer>
  );
};

export default StartupFooter;
